<template>
  <div id="btnContainer">
    <div
      v-for="(state, index) in states"
      :id="state.id + 'Btn'"
      :key="state.id + 'Hotspot'"
      class="position-absolute btn"
      @click="navigateTo(index)"
    >
      <span v-if="showTitle" v-html="state.title"></span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    navigateTo (index) {
      this.$emit('navigate-to', index)
    }
  },
  name: 'Hotspots',
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    states: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>
